import { Grid } from "@mui/material";
import React from "react";
import { Base } from "../../base";
import AddJobNoteForm from "../../forms/AddJobNoteForm";
import { useSelector } from "../../../store";
import JobNoteDisplay from "./JobNoteDisplay";
import AddNoteVM from "../../../types/addNoteVM";

interface Props {
  apiAddNote: (note: AddNoteVM) => void;
  handleRemove?: (id: number, values?: { note?: string }) => void;
  setDeleteModal?: React.Dispatch<
    React.SetStateAction<{
      id: number;
      note?: string | undefined;
      type?: "equipment" | "vendor" | "time" | undefined;
    }>
  >;
}

const JobNoteView: React.FC<Props> = (props) => {
  const { apiAddNote } = props;
  const { job } = useSelector((store) => store.job);
  const { loggedInUser } = useSelector((store) => store.authentication);

  const addNote = (values: { note: string }) => {
    const newJobNote: AddNoteVM = {
      jobId: job.id,
      note: values.note,
      createdBy: loggedInUser,
    };
    apiAddNote(newJobNote);
  };

  return (
    <Grid container direction={"column"}>
      <Grid pb={2}>
        <Grid container direction={"row"} justifyContent={"space-between"}>
          <Grid>
            <Base.Text text="Notes" variant="h3" />
          </Grid>
          <Grid m={"18px"} />
        </Grid>
        <AddJobNoteForm handleSubmit={addNote} />
      </Grid>
      <Grid sx={{ maxHeight: 350, overflow: "auto", mb: 1 }}>
        {job.jobNotes.map((note, index) => (
          <JobNoteDisplay note={note} key={index} {...props} />
        ))}
      </Grid>
    </Grid>
  );
};

export default JobNoteView;
